module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.fileInfo.addFolderShow),
      expression: "$store.state.fileInfo.addFolderShow"
    }],
    ref: "maskPosition",
    staticClass: "mask",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticStyle: {
      "height": "3.52rem"
    }
  }, [_c('p', {
    staticClass: "dialog-title"
  }, [_c('span', [_vm._v("新建文件夹")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorInfo),
      expression: "errorInfo"
    }],
    staticStyle: {
      "color": "red",
      "height": "0.61rem",
      "display": "block",
      "font-size": "0.32rem"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))])]), _vm._v(" "), _c('p', {
    staticClass: "dialog-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.fileName),
      expression: "fileName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "focus": function($event) {
        _vm.focusAbsolute()
      },
      "blur": [function($event) {
        _vm.blurFixed()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value.trim()
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "dialog-button"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "ok",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6856e894","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filelist/filelist_add_folder.vue
// module id = 222
// module chunks = 3